import {useCallback, useEffect, useMemo, useRef} from 'react';
import {
    AudioPlayerBody, AudioPlayerExtraSpace,
    AudioPlayerWrapper,
    AudioTitle,
    AudioTitleText,
    AudioTitleTrack,
    CloseAudioIconWrapper, FixedAudioPlayerWrapper, IPhoneSwitcherLabel
} from "./styles";
import {FlexBox, useBreakpoint} from "@brg/ui";
import {SpeedComponent} from "./components/SpeedComponent";
import {VolumeComponent} from "./components/VolumeComponent";
import {PlayComponent} from "./components/PlayComponent";
import {TimeComponent} from "./components/TimeComponent";
import {CloseIcon} from "../../icons";
import {useDispatch, useSelector} from "react-redux";
import {
    clearAudio,
    selectorAudioIsAutoScroll,
    selectorAudioIsHidden, selectorAudioIsPlaying,
    selectorAudioPostId, setAudioIsAutoScroll,
    setAudioIsHidden
} from "./reducers/AudioSlice";
import {useGetAudioPost} from "./hooks/useGetAudioPost";
import {Endpoints} from "@brg/api";
import {useTimecodesListener} from "./hooks/useTimecodesListener";
import {IPhoneSwitcher} from "./components/IPhoneSwitcher";
import {LayoutConst} from "../../../core";
import {useTranslation} from "react-i18next";
import {ExpandIcon} from "./icons/ExpandIcon";
import {HideIcon} from "./icons/HideIcon";
import {OstbayPlayer} from 'ostbay-player';
import { CurrentProjectSelector } from 'shared/reducers/CurrentProject';

export enum PLAYER_TYPE {
    default = 'default',
    ostbay = 'ostbay'
}

const AudioPlayer = () => {

    const audioRef = useRef<HTMLAudioElement>(null);
    const wrapperRef = useRef<HTMLDivElement>(null);
    const ostbayPlayerRef = useRef<HTMLDivElement>(null);
    const isHidden = useSelector(selectorAudioIsHidden)
    const autoScroll = useSelector(selectorAudioIsAutoScroll)
    const postId = useSelector(selectorAudioPostId)
    const [audioPost, isLoading] = useGetAudioPost(postId)
    const dispatch = useDispatch()
    const is992 = useBreakpoint(LayoutConst.screen.m);
    const { t } = useTranslation();
    const is744BP = useBreakpoint(LayoutConst.screen.s)
    const isPlaying = useSelector(selectorAudioIsPlaying)
    const isOstbay = useSelector(CurrentProjectSelector)?.isOstbay

    const onClose = useCallback(() => {
        dispatch(clearAudio())
    }, [])

    // @ts-ignore
    const onHide = useCallback((e) => {
        e.stopPropagation()
        dispatch(setAudioIsHidden(true))
    }, [])

    const playerType = useMemo(() => {
        return Boolean(isOstbay) ? PLAYER_TYPE.ostbay : PLAYER_TYPE.default;
    } , [audioPost, isOstbay])

    const title = useMemo(() => (audioPost?.text || ' .').split('.')[0], [audioPost])
    const audioUrl = useMemo(() => {
        if (!audioPost) return '';
        if (audioPost?.attachments?.length === 0) return '';
        const baseUrl = audioPost?.attachments[0]?.files?.length === 0 ? '' : audioPost?.attachments[0]?.files[0]?.url;
        const ext = baseUrl?.split('.')?.pop();
        if (!baseUrl || !['mp3', 'wav'].includes(ext || '')) return '';
        return Endpoints.files + '/' + baseUrl;
    }, [audioPost])

    useTimecodesListener(audioPost)

    useEffect(() => {
        function handleClickOutside(event: any) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                dispatch(setAudioIsHidden(true))
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    if (isLoading || !audioPost || !audioUrl) {
        return null
    }

    if (playerType === PLAYER_TYPE.ostbay) {
        return null
    }

    // даже в свернутом состоянии надо оставлять все элементы без перерисовок, поэтому не нашел ничего лучше, кроме как их визуально скрывать
    return (
        <FixedAudioPlayerWrapper isHidden={isHidden} ref={wrapperRef}>
            <AudioPlayerExtraSpace isHidden={isHidden} onClick={() => dispatch(setAudioIsHidden(false))}>
                <AudioPlayerWrapper isHidden={isHidden}>
                    <audio ref={audioRef} id="audio-player" src={audioUrl}/>
                    <AudioPlayerBody isHidden={isHidden}>
                        <FlexBox align="center" width='100%' gx={is992 ? 16 : 24}>
                            <PlayComponent audioRef={audioRef} hidden={isHidden}/>
                            <TimeComponent title={title} audioRef={audioRef} hidden={isHidden}/>
                        </FlexBox>
                        <FlexBox align="center" gx={is992 ? 16 : 24} style={{...isHidden && {display: "none"}}}>
                            <SpeedComponent audioRef={audioRef} hidden={isHidden}/>
                            <VolumeComponent audioRef={audioRef} hidden={isHidden}/>
                            {!isHidden && <FlexBox gx={8}><IPhoneSwitcher active={autoScroll} setActive={(value) => dispatch(setAudioIsAutoScroll(value))} /><IPhoneSwitcherLabel>{t('lms.audio.autoscroll')}</IPhoneSwitcherLabel></FlexBox>}
                        </FlexBox>
                    </AudioPlayerBody>
                    {isHidden && !(is744BP && isPlaying) && (
                        <AudioTitle>
                            <AudioTitleTrack>
                                <AudioTitleText>{title}</AudioTitleText>
                            </AudioTitleTrack>
                        </AudioTitle>
                    )}
                    {isHidden && is744BP && !isPlaying && <ExpandIcon/>}
                    {!isHidden && is744BP && <CloseAudioIconWrapper style={{right: '52px'}} onClick={onHide}>
                        <HideIcon />
                    </CloseAudioIconWrapper>}
                    {!isHidden && <CloseAudioIconWrapper>
                        <CloseIcon onClick={onClose}/>
                    </CloseAudioIconWrapper>}
                </AudioPlayerWrapper>
            </AudioPlayerExtraSpace>
        </FixedAudioPlayerWrapper>
    );
};

export default AudioPlayer;import {useCallback, useEffect, useMemo, useRef} from 'react';
import {
    AudioPlayerBody, AudioPlayerExtraSpace,
    AudioPlayerWrapper,
    AudioTitle,
    AudioTitleText,
    AudioTitleTrack,
    CloseAudioIconWrapper, FixedAudioPlayerWrapper, IPhoneSwitcherLabel
} from "./styles";
import {FlexBox, useBreakpoint} from "@brg/ui";
import {SpeedComponent} from "./components/SpeedComponent";
import {VolumeComponent} from "./components/VolumeComponent";
import {PlayComponent} from "./components/PlayComponent";
import {TimeComponent} from "./components/TimeComponent";
import {CloseIcon} from "../../icons";
import {useDispatch, useSelector} from "react-redux";
import {
    clearAudio,
    selectorAudioIsAutoScroll,
    selectorAudioIsHidden, selectorAudioIsPlaying,
    selectorAudioPostId, setAudioIsAutoScroll,
    setAudioIsHidden
} from "./reducers/AudioSlice";
import {useGetAudioPost} from "./hooks/useGetAudioPost";
import {Endpoints} from "@brg/api";
import {useTimecodesListener} from "./hooks/useTimecodesListener";
import {IPhoneSwitcher} from "./components/IPhoneSwitcher";
import {LayoutConst} from "../../../core";
import {useTranslation} from "react-i18next";
import {ExpandIcon} from "./icons/ExpandIcon";
import {HideIcon} from "./icons/HideIcon";
import {OstbayPlayer} from 'ostbay-player';
import { CurrentProjectSelector } from 'shared/reducers/CurrentProject';

export enum PLAYER_TYPE {
    default = 'default',
    ostbay = 'ostbay'
}

const AudioPlayer = () => {

    const audioRef = useRef<HTMLAudioElement>(null);
    const wrapperRef = useRef<HTMLDivElement>(null);
    const ostbayPlayerRef = useRef<HTMLDivElement>(null);
    const isHidden = useSelector(selectorAudioIsHidden)
    const autoScroll = useSelector(selectorAudioIsAutoScroll)
    const postId = useSelector(selectorAudioPostId)
    const [audioPost, isLoading] = useGetAudioPost(postId)
    const dispatch = useDispatch()
    const is992 = useBreakpoint(LayoutConst.screen.m);
    const { t } = useTranslation();
    const is744BP = useBreakpoint(LayoutConst.screen.s)
    const isPlaying = useSelector(selectorAudioIsPlaying)
    const isOstbay = useSelector(CurrentProjectSelector)?.isOstbay

    const onClose = useCallback(() => {
        dispatch(clearAudio())
    }, [])

    // @ts-ignore
    const onHide = useCallback((e) => {
        e.stopPropagation()
        dispatch(setAudioIsHidden(true))
    }, [])

    const playerType = useMemo(() => {
        return Boolean(isOstbay) ? PLAYER_TYPE.ostbay : PLAYER_TYPE.default;
    } , [audioPost, isOstbay])

    const title = useMemo(() => (audioPost?.text || ' .').split('.')[0], [audioPost])
    const audioUrl = useMemo(() => {
        if (!audioPost) return '';
        if (audioPost?.attachments?.length === 0) return '';
        const baseUrl = audioPost?.attachments[0]?.files?.length === 0 ? '' : audioPost?.attachments[0]?.files[0]?.url;
        const ext = baseUrl?.split('.')?.pop();
        if (!baseUrl || !['mp3', 'wav'].includes(ext || '')) return '';
        return Endpoints.files + '/' + baseUrl;
    }, [audioPost])

    useTimecodesListener(audioPost)

    useEffect(() => {
        function handleClickOutside(event: any) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                dispatch(setAudioIsHidden(true))
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    if (isLoading || !audioPost || !audioUrl) {
        return null
    }

    if (playerType === PLAYER_TYPE.ostbay) {
        return null
    }

    // даже в свернутом состоянии надо оставлять все элементы без перерисовок, поэтому не нашел ничего лучше, кроме как их визуально скрывать
    return (
        <FixedAudioPlayerWrapper isHidden={isHidden} ref={wrapperRef}>
            <AudioPlayerExtraSpace isHidden={isHidden} onClick={() => dispatch(setAudioIsHidden(false))}>
                <AudioPlayerWrapper isHidden={isHidden}>
                    <audio ref={audioRef} id="audio-player" src={audioUrl}/>
                    <AudioPlayerBody isHidden={isHidden}>
                        <FlexBox align="center" width='100%' gx={is992 ? 16 : 24}>
                            <PlayComponent audioRef={audioRef} hidden={isHidden}/>
                            <TimeComponent title={title} audioRef={audioRef} hidden={isHidden}/>
                        </FlexBox>
                        <FlexBox align="center" gx={is992 ? 16 : 24} style={{...isHidden && {display: "none"}}}>
                            <SpeedComponent audioRef={audioRef} hidden={isHidden}/>
                            <VolumeComponent audioRef={audioRef} hidden={isHidden}/>
                            {!isHidden && <FlexBox gx={8}><IPhoneSwitcher active={autoScroll} setActive={(value) => dispatch(setAudioIsAutoScroll(value))} /><IPhoneSwitcherLabel>{t('lms.audio.autoscroll')}</IPhoneSwitcherLabel></FlexBox>}
                        </FlexBox>
                    </AudioPlayerBody>
                    {isHidden && !(is744BP && isPlaying) && (
                        <AudioTitle>
                            <AudioTitleTrack>
                                <AudioTitleText>{title}</AudioTitleText>
                            </AudioTitleTrack>
                        </AudioTitle>
                    )}
                    {isHidden && is744BP && !isPlaying && <ExpandIcon/>}
                    {!isHidden && is744BP && <CloseAudioIconWrapper style={{right: '52px'}} onClick={onHide}>
                        <HideIcon />
                    </CloseAudioIconWrapper>}
                    {!isHidden && <CloseAudioIconWrapper>
                        <CloseIcon onClick={onClose}/>
                    </CloseAudioIconWrapper>}
                </AudioPlayerWrapper>
            </AudioPlayerExtraSpace>
        </FixedAudioPlayerWrapper>
    );
};

export default AudioPlayer;